import React, { useState } from 'react';
import OtpInput from 'react-otp-input';
import { IoCloseSharp } from 'react-icons/io5';
import { PropsFromRedux } from '.';
import  './WalletPinSetup.scss';



interface Props extends PropsFromRedux {}

const WalletPinSetup: React.FC<Props> = ({ hideModal, showModal, modal }) => {

  const [otp, setOtp] = useState('');

  const handleChange = (code:any) => { 
    setOtp(code)
   }
  const closeModal = () => {
    hideModal();
  };

  const showConfirmPinSetup = () => {
    if(otp.length == 4) {
      hideModal();
      showModal({
        component: 'ConfirmWalletPin',
        modalProps: {
          contentLabel: 'Confirm Wallet Pin',
        }, 
        ownProps: {
          walletpin: otp
        }
      });
    }
  }
  
  // <ModalWrapper hideCloseButton hideModal={hideModal}>
  return(
    <div className="w-full px-8 bg-white lg:px-24 py-10 relative">
        <button type="button" aria-label="Close" onClick={closeModal}>
        <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
      </button>
     <div className="w-full my-2 text-center">
         <h2 className="mb-1 text-2xl font-bold text-black">Wallet pin set up</h2>
      </div>
      <div className="w-full max-w-md mx-auto text-center mb-10 text-sm">
        <p className="text-gray-500 my-4">
            Kindly enter your one-time wallet pin
       </p>
       <div>
       <OtpInput 
       inputStyle="otp-field"
        value={otp}
        onChange={handleChange}
        numInputs={4}
        isInputSecure={true}
        separator={<span> </span>}
      />
       </div>
      </div>
      <button className="w-full bg-secondary font-medium text-sm rounded text-white py-4" type="button" onClick={() => showConfirmPinSetup()}>Continue</button>
  </div>
  );
  // </ModalWrapper>
};

export default WalletPinSetup;
